export default "__VITE_ASSET__ef9b91fc__"